/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { Action, isType } from 'typescript-fsa';
import { PlaylistStatistic } from '../../../services/playlist';
import { setPlaylistStatistics } from './actions';

export interface PlaylistStatisticState {
    statistic: PlaylistStatistic;
}

const initialPlaylistStatisticState: PlaylistStatisticState = {
    statistic: {
        totalNumberOfDistinctUsersInUserSongs: 0,
        totalNumberOfSongs: 0,
        totalNumberOfUserSongs: 0,
        totalNumberOfSongsWithUrl: 0,
        totalNumberOfSongsWithAlbum: 0,
        totalNumberOfAlbums: 0,
        totalNumberOfAlbumWithCover: 0,
        totalNumberOfAlbumsComplete: 0
    }
};

export const playlistStatisticReducer = (state: PlaylistStatisticState = initialPlaylistStatisticState,
                                         action: Action<{}>) => {
    if (isType(action, setPlaylistStatistics)) {
        return Object.assign({}, state, {statistic: action.payload});
    }
    return state;
};